import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const overlayDefaultVariants = {}
const overlayCompoundVariants = []

const overlaySlotNames = [
  [
    "root",
    "Overlay__root"
  ]
]
const overlaySlotFns = /* @__PURE__ */ overlaySlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, overlayDefaultVariants, getSlotCompoundVariant(overlayCompoundVariants, slotName))])

const overlayFn = memo((props = {}) => {
  return Object.fromEntries(overlaySlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const overlayVariantKeys = [
  "isContained"
]
const getVariantProps = (variants) => ({ ...overlayDefaultVariants, ...compact(variants) })

export const overlay = /* @__PURE__ */ Object.assign(overlayFn, {
  __recipe__: false,
  __name__: 'overlay',
  raw: (props) => props,
  variantKeys: overlayVariantKeys,
  variantMap: {
  "isContained": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, overlayVariantKeys)
  },
  getVariantProps
})